import type { MarketingCampaignQuerySchema } from '../schemas';

export const fieldNames: Record<keyof MarketingCampaignQuerySchema, { name: string; revertible: boolean }> = {
  id: { name: 'ID', revertible: false },
  name: { name: 'Campaign Name', revertible: false },
  campaign_type: { name: 'Type', revertible: false },
  date: { name: 'Date', revertible: false },
  notes: { name: 'Notes', revertible: false },
  total_cost_of_campaign: { name: 'Cost', revertible: false },
  clients: { name: 'Clients', revertible: false },
  contacts: { name: 'Contacts', revertible: false },
  attached_files: { name: 'Documents', revertible: false },
  contacts_count: { name: 'Contacts', revertible: false },
};
